'use client';

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import Header from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dynamic from "next/dynamic";
import { useActivityTracking } from "@/hooks/useActivityTracking";
import { useLoading } from "@/context/LoadingContext";

const UnifiedChatbot = dynamic(() => import("@/components/UnifiedChatbot"), { ssr: false });

export default function ClientLayout({ children }) {
  const pathname = usePathname();
  const { hideLoading, isInitialLoad } = useLoading();
  const isAdminPage = pathname?.startsWith("/admin");
  const isTrustInnPage = pathname?.startsWith("/trustinn");
  const isAboutUsPage = pathname === "/about-us";
  const isHomePage = pathname === "/";
  
  // Initialize activity tracking
  useActivityTracking();

  useEffect(() => {
    // Only hide loading on initial mount
    if (isInitialLoad) {
      const timer = setTimeout(() => hideLoading(), 500);
      return () => clearTimeout(timer);
    }
  }, [isInitialLoad, hideLoading]);

  useEffect(() => {
    // Ensure light theme is always applied
    document.documentElement.classList.remove('dark');
    document.documentElement.style.backgroundColor = '#ffffff';
    document.body.style.backgroundColor = '#ffffff';
    document.documentElement.style.color = '#000000';
    document.body.style.color = '#000000';
  }, []);

  if (isAdminPage) {
    return (
      <div className="min-h-screen bg-white">
        {children}
        <ToastContainer theme="light" />
      </div>
    );
  }

  // Home page has its own complete layout with footer, no header needed
  if (isHomePage) {
    return (
      <div className="flex flex-col min-h-screen bg-white">
        <Header/>
        <main className="flex-grow">
          {children}
        </main>
        <ToastContainer theme="light" />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {!isTrustInnPage && !isAboutUsPage && <Header />}
      
      <main className="flex-grow">
        {children}
      </main>
      {!isTrustInnPage && <UnifiedChatbot />}
      {!isTrustInnPage && <Footer />}
      <ToastContainer theme="light" />
    </div>
  );
}
